import PropTypes from 'prop-types'
import React from 'react'

import { defaultToEmptyString } from '../../../assets/ts/formatting/formatting'

const CustomerDetails = ({ detailsitems }) => {
  return (
    <>
      <div className='d-flex align-items-center flex-wrap py-2 w-100'>
        {detailsitems.map((detailsdata) => (
          <div
            aria-label={`${detailsdata.title} ${detailsdata.subtitle}`}
            className='sourcesanspro mb-2 col-lg-3 col-md-6 col-sm-12 font-12 text-break'
            key={detailsdata.title}
            tabIndex={0}
          >
            <p className='title-color24'>{defaultToEmptyString(detailsdata.title)}</p>
            <p className='title-color'>{defaultToEmptyString(detailsdata.subtitle)}</p>
          </div>
        ))}
      </div>
      <div className='mt-2 font-13 d-none'>
        <div
          aria-label='Description'
          className='subtitle-color pb-1'
          tabIndex={0}
        >
          Description
        </div>
        <div
          aria-describedby='details-description'
          id='details-description'
          tabIndex={0}
        >
          <p className='pb-2'>Para contant</p>
        </div>
      </div>
    </>
  )
}
CustomerDetails.propTypes = {
  detailsitems: PropTypes.array,
}
export default CustomerDetails
